document.addEventListener('DOMContentLoaded', function () {
  const polyDisplay = document.querySelector('#polyphenols-value');
  if (!polyDisplay) return;

  const variantData = JSON.parse(polyDisplay.dataset.variantPolys);

  // Function to update polyphenols display
  const updatePoly = (variantId) => {
    const match = variantData.find(v => v.id === variantId);
    polyDisplay.textContent = match?.poly || polyDisplay.dataset.productPoly || '';
  };

  // Listen for variant change events
  document.addEventListener('variant:changed', event => {
    const variant = event.detail.variant;
    if (!variant) return;
    updatePoly(variant.id);
  });

  // Also try updating if variant selector changes directly (fallback)
  const variantSelector = document.querySelector('select[name="id"]');
  if (variantSelector) {
    variantSelector.addEventListener('change', (e) => {
      const selectedId = parseInt(e.target.value);
      updatePoly(selectedId);
    });
  }
});